import { getStorage, ref, getDownloadURL } from "firebase/storage";
import localforage from "localforage";
const storage = getStorage();

export async function fetchAndCacheImage(imagePath) {
    try {
      const cachedUrl = await localforage.getItem(imagePath);
      if (cachedUrl) return cachedUrl;

      const imageRef = ref(storage, imagePath);
      const url = await getDownloadURL(imageRef);
      await localforage.setItem(imagePath, url);
      return url;
    } catch (error) {
      console.error("Error fetching and caching image:", error);
      return null;
    }
  }